import { render, staticRenderFns } from "./ReservaBiosferaParaguai.vue?vue&type=template&id=41c584cc&lang=pug"
import script from "./ReservaBiosferaParaguai.vue?vue&type=script&lang=js"
export * from "./ReservaBiosferaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports